import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { LocalizationProvider } from './context/LocalizationContext';
import { Shell } from './components/Shell';
import { Assets } from './pages/Assets';
import { Attendance } from './pages/Attendance';
import { AuditTrail } from './pages/AuditTrail';
import { AccessControl } from './pages/AccessControl';
import { BulkImport } from './pages/BulkImport';
import { Dashboard } from './pages/Dashboard';
import { Departments } from './pages/Departments';
import { DocumentCenter } from './pages/DocumentCenter';
import { EmployeeDetail } from './pages/EmployeeDetail';
import { Employees } from './pages/Employees';
import { Exit } from './pages/Exit';
import { Expenses } from './pages/Expenses';
import { Finance } from './pages/Finance';
import { Grievances } from './pages/Grievances';
import { Leaves } from './pages/Leaves';
import { Loans } from './pages/Loans';
import { Payroll } from './pages/Payroll';
import { Recruitment } from './pages/Recruitment';
import { SignIn } from './pages/SignIn';
import './styles.css';

function App() {
  const { session } = useAuth();
  if (!session) return <SignIn />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/employees/:id" element={<EmployeeDetail />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/leaves" element={<Leaves />} />
        <Route path="/payroll" element={<Payroll />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/loans" element={<Loans />} />
        <Route path="/assets" element={<Assets />} />
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/documents" element={<DocumentCenter />} />
        <Route path="/grievances" element={<Grievances />} />
        <Route path="/exit" element={<Exit />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/access-control" element={<AccessControl />} />
        <Route path="/bulk-import" element={<BulkImport />} />
        <Route path="/audit" element={<AuditTrail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LocalizationProvider>
          <App />
        </LocalizationProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

